import Alert from '../../../../components/Alert'
import Modal from '../../../../components/Modal'
import DropdownMenu from '../../../../components/DropdownMenu'

import { memo, useState, useEffect, useContext, useCallback, useMemo } from 'react'
import WorkCenterForm from '../../WorkCenterForm'
import EditWorkCenter from '../../EditWorkCenter'
import SaveDraftDialogBulk from '../../SaveDraftDialogBulk'
import SaveDraftDialogFG from '../../SaveDraftDialogFG'
import BulkInspectForm from '../../BulkInspectForm'

import { OperationTime, OperationTimeQC, OrderStatusCode, OrderType, QCDowntimeCodes } from '../../../../constants/Enum'
import { DgtPdOrderOperation, DgtPdOrderOperationLog, DgtPdProductionOrder, DgtPdWorkCenter } from '../../../../models'
import { DataStore } from '@aws-amplify/datastore'
import OperationLogTable from '../../../Tables/OperationLogTable'
import SelectWorkCenter from '../../SelectWorkCenter'
import UserContext from '../../../../contexts/UserContext'
import SyncExpressionContext from '../../../../contexts/SyncExpressionContext'
import RecordTimeTypeContext from '../../../../contexts/RecordTimeTypeContext'
import { countEditWc, validateRtOtLogs } from '../logic'
import { BsStopwatch } from 'react-icons/bs'
import { BiChip } from 'react-icons/bi'
import { RiUserUnfollowLine } from 'react-icons/ri'
import { HiMagnifyingGlass } from 'react-icons/hi2'
import { AiOutlineFileDone } from 'react-icons/ai'
import { Switch } from '@headlessui/react'
import { PubSub, Auth } from 'aws-amplify'
import { 
  IoTClient,
  AttachPolicyCommand,
  ListAttachedPoliciesCommand
} from "@aws-sdk/client-iot";
import { 
  MachineStatusIotTopics,
  WeightScaleIotTopics
} from '../../../../constants/IotTopics'
import { Department } from '../../../../models'
import DataGrid, { CalculatedColumn } from 'react-data-grid'
import { InspectBulkLogsColumns } from '../../../../constants/Column'
import Badge from '../../../../components/Badge'
import { OrderStatusDisplay, OrderStatusTheme } from '../../../../constants/Enum'
import FGInspection from '../../../../components/FGInspection'
import useFGInpsectionLog from "../../../../hooks/useFGInspectionLog";
import { formatNumberV2, ceil2Decimal } from '../../../../utilities/Format'

import { 
  updateDraftDirectly,
  updateCountEditOperationDirectly,
  updateCountEditWorkCenterDirectly
} from '../../../../apis'

let iotSub;

const WorkCenterDraft = ({ order, workCenters, setOrder, unSubFunc, disableRecord = false }) => {
  const firstOpID = workCenters.length > 0 ? workCenters[0].operationNo : ''
  const [currentOperationNo, setCurrentOperationNo] = useState(firstOpID)

  const [editLogId, setEditLogId] = useState('')

  const [showEditWc, setShowEditWc] = useState(false)

  const [showDialogAddOp, setShowDialogAddOp] = useState(false)

  const [showConfirmDelete, setShowConfirmDelete] = useState(false)

  const [showConfirmDisableOp, setShowConfirmDisableOp] = useState(false)

  const [showConfirmSaveDraft, setShowConfirmSaveDraft] = useState(false)

  const [logIdForDelete, setLogIdForDelete] = useState('')

  const [logForView, setLogForView] = useState()

  const [operationLogs, setOperationLogs] = useState([])

  const [updatedOperations, setUpdatedOperations] = useState(null)

  const [showToast, setShowToast] = useState(false);

  const [ iotEnable , setIotEnabled] = useState(false)
  
  const [showErrorIot, setShowErrorIot] = useState(null);

  const [ iotStartTime , setIotStartTime ] = useState(0)
  const [ iotStopTime , setIotStopTime ] = useState(0)
  const [ iotWeight , setIotWeight ] = useState({ weight: 0, timestamp: '' })

  const [ invalidRtOt , setInvalidRtOt] = useState(false)

  const [ showBulkInspectForm, setShowBulkInspectForm ] = useState(false)

  const [ showFgInspectForm, setShowFgInspectForm ] = useState(false)

  const [ isRefresh, setIsRefresh ] = useState(false)

  const defaultNewOperation = {
    operationNo: workCenters.length > 0 ? `${parseInt(workCenters[workCenters.length - 1].operationNo) + 10}`.padStart(4, '0') : '',
    workCenterId: '',
    workCenterDescription: '',
    error: ''
  }
  const [newOperation, setNewOperation] = useState(defaultNewOperation)

  const { user, readOnly } = useContext(UserContext)
  const { setSyncOperationID } = useContext(SyncExpressionContext)
  const { currentTimeType, setCurrentTimeType } = useContext(RecordTimeTypeContext)

  const currentUser: any = user;
  const currentDepartment : Department = currentUser.department;

  const currentOperation = useMemo(() => {
    const originWc = workCenters.find(wc => wc.operationNo === currentOperationNo)
    if (updatedOperations) {
      const updatedWc = updatedOperations[currentOperationNo]
      return { ...originWc, ...updatedWc }
    }
    return originWc
  }, [ workCenters, currentOperationNo, updatedOperations ])

  const onEditWorkCenterCompleted = async (selectedWorkCenter, newWc) => {
    if (!newWc) {
      setShowEditWc(false)
      return
    }
    try {
      const originalOperation = await DataStore.query(DgtPdOrderOperation, selectedWorkCenter.id)
      if (originalOperation) {
        const updateOperation = DgtPdOrderOperation.copyOf(originalOperation, updated => {
          updated.actualWorkCenterId = newWc.id
          updated.actualWorkCenterDescription = newWc.description
        })
        await DataStore.save(updateOperation)

        const updatedOps = {
          ...updatedOperations,
          [originalOperation.operationNo]: {
            ...updateOperation,
            isRequiredManHour: newWc.isRequiredManHour,
            isRequiredBatchLotNo: newWc.isRequiredBatchLotNo !== null ? newWc.isRequiredBatchLotNo : true,
            isRequiredFGInspect: newWc.isRequiredFGInspect !== null ? newWc.isRequiredFGInspect : false,
            machineCategory: newWc.machineCategory || null,
            sapCategoryCode: newWc.sapCategoryCode || null,
            sapCategoryName: newWc.sapCategoryName || null
          }
        }
        await updateCountEditWorkCenter(updatedOps)
        
        setUpdatedOperations(updatedOps)
      }
    } catch (error) {
      console.log(error)
    }
    setShowEditWc(false)
  }

  const onConfirmEnableDisableOp = async () => {
    try {
      const originalOperation = await DataStore.query(DgtPdOrderOperation, currentOperation.id)
      if (originalOperation) {
        const updateOperation = DgtPdOrderOperation.copyOf(originalOperation, updated => {
          updated.active = !originalOperation.active
        })
        await DataStore.save(updateOperation)

        const updatedOps = {
          ...updatedOperations,
          [originalOperation.operationNo]: updateOperation
        }

        await updateCountEditOperation(updatedOps)

        setUpdatedOperations(updatedOps)

        updateDraftedToOrder(updatedOps)
      }
    } catch (error) {
      console.log(error)
    }
    setShowConfirmDisableOp(false)
  }

  const onClickStartRecord = (timeType) => {
    const processingLogs = operationLogs.filter(log => !log.finishedTime && !QCDowntimeCodes.includes(log.downtimeCode))
    if (processingLogs.length > 0 && processingLogs[0].timeType !== timeType) {
      setShowToast(true)
      setTimeout(() => {
        setShowToast(false)
      }, 3000)
      updateNowFinishedLog(processingLogs[0].id)
    }

    setCurrentTimeType(timeType)
  }

  const updateNowFinishedLog = async(logId) => {
    const originaLog = await DataStore.query(DgtPdOrderOperationLog, logId)
    if (originaLog) {
      const now = Math.round(Date.now() / 1000)
      await DataStore.save(DgtPdOrderOperationLog.copyOf(originaLog, updated => {
        updated.finishedTime = now
        updated.totalTime = now - originaLog.startedTime
        updated.updatedBy = user?.name || user?.username
      }))
    }
  }

  const onEditRecord = (logId, dwCode) => {
    if (user.department === Department.QC && !QCDowntimeCodes.includes(dwCode)) return

    setEditLogId(logId)
    setCurrentTimeType(OperationTime.SETUP_TIME)
  }

  const onDeleteRecord = (logId, dwCode) => {
    if (user.department === Department.QC && !QCDowntimeCodes.includes(dwCode)) return

    setShowConfirmDelete(true)
    setLogIdForDelete(logId)
  }

  const onViewRecord = async (logId) => {
    const viewLog = await DataStore.query(DgtPdOrderOperationLog, logId);
    setLogForView(viewLog)
  }

  const onConfirmDelete = async () => {
    try {
      const logForDelete = await DataStore.query(DgtPdOrderOperationLog, logIdForDelete);
      DataStore.delete(logForDelete);
    } catch (error) {
      console.log(error)
    }
    setShowConfirmDelete(false)
    setLogIdForDelete('')
    const cloneLogs = [...operationLogs]
    const idxForRemove = cloneLogs.findIndex(lg => lg.id === logIdForDelete)
    cloneLogs.splice(idxForRemove, 1);
    setOperationLogs(cloneLogs)
  }

  const onNewOperationNoChanged = (e) => {
    const currentNewOperation = { ...newOperation }
    currentNewOperation.operationNo = e.currentTarget.value
    setNewOperation(currentNewOperation)
  }

  const onNewOperationWcChanged = (e) => {
    const currentNewOperation = { ...newOperation }
    const splitted = e.value.split('_')
    currentNewOperation.workCenterId = splitted[0]
    currentNewOperation.workCenterDescription = splitted[1]
    setNewOperation(currentNewOperation)
  }

  const onSetFirstNewOperationWc = (value) => {
    const currentNewOperation = { ...newOperation }
    const splitted = value.split('_')
    currentNewOperation.workCenterId = splitted[0]
    currentNewOperation.workCenterDescription = splitted[1]
    setNewOperation(currentNewOperation)
  }

  const onConfirmAddNewOp = async () => {
    if (workCenters.map(wc => wc.operationNo).includes(newOperation.operationNo)) {
      const currentNewOperation = { ...newOperation }
      currentNewOperation.error = 'เลขรหัส Op ซ้ำ กรุณาใส่ใหม่'
      setNewOperation(currentNewOperation)
      return
    }
    try {
      const now = new Date()
      const insertOperation = new DgtPdOrderOperation({
        "active": true,
        "operationNo": newOperation.operationNo,
        "productionOrderId": order.id,
        "workCenterDescription": newOperation.workCenterDescription,
        "workCenterId": newOperation.workCenterId,
        "createdAt": now.toISOString(),
        "createdBySystem": "APP"
      })
      await DataStore.save(insertOperation)

      const newWcFlags = await getFlagsOfWorkCenter(newOperation.workCenterId)
      const updateOps = {
        ...updatedOperations,
        [newOperation.operationNo]: {
          ...insertOperation,
          isRequiredManHour: newWcFlags.isRequiredManHour,
          isRequiredBatchLotNo: newWcFlags.isRequiredBatchLotNo,
          isRequiredFGInspect: newWcFlags.isRequiredFGInspect,
          machineCategory: newWcFlags.machineCategory,
          sapCategoryCode: newWcFlags.sapCategoryCode,
          sapCategoryName: newWcFlags.sapCategoryName
        }
      }
      console.log('updateOps', updateOps)
      await updateCountEditOperation(updateOps)

      setUpdatedOperations(updateOps)

      setNewOperation({
        ...defaultNewOperation, operationNo:
          `${parseInt(newOperation.operationNo) + 10}`.padStart(4, '0')
      })
    } catch (error) {
      console.log(error)
    }
    setShowDialogAddOp(false)
  }

  const onConfirmSaveDraftOperation = async (id) => {
    try {
      const originalOperation = await DataStore.query(DgtPdOrderOperation, id)
      if (originalOperation) {
        const now = new Date()
        const updateOperation = DgtPdOrderOperation.copyOf(originalOperation, updated => {
          updated.status = OrderStatusCode.DRAFTED
          updated.draftedDate = now.toISOString()
          updated.draftedBy = user?.name || user?.username
        })
        await DataStore.save(updateOperation)

        const newUpdateOperations = {
          ...updatedOperations,
          [originalOperation.operationNo]: updateOperation
        }
        setUpdatedOperations(newUpdateOperations)

        updateDraftedToOrder(newUpdateOperations)
      }
    } catch (error) {
      console.log(error)
    }
    setShowConfirmSaveDraft(false)
  }

  const updateDraftedToOrder = async (newUpdateOperations) => {
    // filter only active operation
    const mergedWorkCenters = mergeUpdateToOriginWorkCenters(workCenters, newUpdateOperations)
    const activeOperations = mergedWorkCenters.filter(op => op.active)
    const countOfDrafted = activeOperations.reduce((prev, cur) => prev +
      (cur.status && cur.status === OrderStatusCode.DRAFTED), 0)

    const originalOrder = await DataStore.query(DgtPdProductionOrder, order.id)
    if (originalOrder) {
      let updateStatus = originalOrder.statusFromApp
      if (countOfDrafted === activeOperations.length) {
        updateStatus = OrderStatusCode.DRAFTED
      } 
      // else if (countOfDrafted === 0) {
      //   updateStatus = OrderStatusCode.READY
      // }
      const updatedOrder = DgtPdProductionOrder.copyOf(originalOrder, updated => {
        updated.statusFromApp = updateStatus
      })
      await DataStore.save(updatedOrder)
      setOrder(updatedOrder)
    } else {
      if (countOfDrafted === activeOperations.length) {
        const updatedOrder = await updateDraftDirectly(order.id, order._version)
        console.log('update to server', updatedOrder)
        setOrder(updatedOrder)
      }
    }
  }

  const updateCountEditWorkCenter = async (updatedOps) => {
    const mergedWorkCenters = mergeUpdateToOriginWorkCenters(workCenters, updatedOps)

    const originalOrder = await DataStore.query(DgtPdProductionOrder, order.id)
    if (originalOrder) {
      const updateOrder = DgtPdProductionOrder.copyOf(originalOrder, updated => {
        updated.countEditWorkCenter = countEditWc(mergedWorkCenters)
      })
      await DataStore.save(updateOrder)
      setOrder(updateOrder)
    } else {
      const updatedOrder = await updateCountEditWorkCenterDirectly(order.id, order._version, countEditWc(mergedWorkCenters))
      setOrder(updatedOrder)
    }
  }

  const updateCountEditOperation = async (updatedOps) => {
    const mergedWorkCenters = mergeUpdateToOriginWorkCenters(workCenters, updatedOps)

    const originalOrder = await DataStore.query(DgtPdProductionOrder, order.id)
    if (originalOrder) {
      const updateOrder = DgtPdProductionOrder.copyOf(originalOrder, updated => {
        updated.countEditOperation = countEditOperation(mergedWorkCenters)
      })
      await DataStore.save(updateOrder)
      setOrder(updateOrder)
    } else {
      const updatedOrder = await updateCountEditOperationDirectly(order.id, order._version, countEditOperation(mergedWorkCenters))
      setOrder(updatedOrder)
    }
  }

  useEffect(() => {
    setSyncOperationID(currentOperationNo)
    const subscription = DataStore.observeQuery(
      DgtPdOrderOperationLog,
      log => log.productionOrderId('eq', order.id).operationNo('eq', currentOperationNo)
    ).subscribe(snapshot => {
      const { items } = snapshot;
      setOperationLogs(items)
    });
    return () => subscription.unsubscribe()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order, currentOperationNo])

  const onBackFromRecord = () => {
    setCurrentTimeType('')
    setEditLogId('')
  }

  const onFinishedProduce = () => {
    if (currentOperation.isRequiredManHour ||  Number(currentOperationNo) >= 20) {
      // action : validate
      if (validateRtOtLogs(operationLogs)) {
        setShowConfirmSaveDraft(true)
        setInvalidRtOt(false)
      } else {
        setInvalidRtOt(true)
      }
    } else {
      // action : no validate (isRequiredMh = false and op = 0010)
      setShowConfirmSaveDraft(true)
      setInvalidRtOt(false)
    }
  }

  const iotEvent = useCallback((data) => {
    const symbolKey = Reflect.ownKeys(data.value)
      .find(key => key.toString() === 'Symbol(topic)')
    const topic = data.value[symbolKey]
    if (topic.includes('get/rejected')) {
      const errorCode = data.value.code
      const errorMessage = errorCode === 404 ? 'Work Center นี้ไม่พบการเชื่อมต่อ IOT แต่ยังบันทึกงานปกติได้' : data.value.message
      setShowErrorIot({ errorCode, errorMessage })
      return
    }

    if (topic.includes('machine_status')) {
      const status = data.value.state.desired.status
      const timestamp = data.value.state.desired.current_time
      console.log('machine_status received', status + ' at '+timestamp)
      
      if (status === 'on') setIotStartTime(Number(timestamp) || 0)
      else setIotStopTime(Number(timestamp) || 0)

    } else if (topic.includes('Weight_Scale')) {
      const weight = data.value.state.desired.weight
      const timestamp = data.value.state.desired.current_time
      setIotWeight({ weight, timestamp })
    }
  }, [])

  const subscriptionIot = async () => {
    const credentials = await Auth.currentCredentials()
    const iotClient = new IoTClient({ region: 'ap-southeast-1', credentials });
    const listPoliciesCmd = new ListAttachedPoliciesCommand({
      target: credentials.identityId
    });
    const policies = await iotClient.send(listPoliciesCmd);
    // check only size == 0 :))
    if (policies.policies.length === 0) {
      // attach policy before
      console.log('iot', 'AttachPolicyCommand')
      const command = new AttachPolicyCommand({
        policyName: 'dgt-prd-iot-policy',
        target: credentials.identityId
      });
      await iotClient.send(command);
    }
    // subscribe
    console.log('iot', 'subscribe')
    const workCenterId = currentOperation.actualWorkCenterId ? currentOperation.actualWorkCenterId : currentOperation.workCenterId
    const iotWc = await DataStore.query(DgtPdWorkCenter, workCenterId)

    const topics = order.materialType === OrderType.FG ? 
      MachineStatusIotTopics(workCenterId) : WeightScaleIotTopics(iotWc.iotId)

    iotSub = PubSub.subscribe(topics).subscribe({
      complete: () => console.log('Done'),
      next: iotEvent,
      error: error => {
        console.error('iot error', error)
        setShowErrorIot({ errorCode: 500, errorMessage: 'Connection Timeout. กรุณาเชื่อมต่อ IOT อีกครั้ง' })
      }
    })

    setIotEnabled(true)
  }

  const onSwitchConnectChanged = (enable) => {
    if (enable) {
      subscriptionIot()
    } else {
      unSubscribeIot()
    }
  }

  const unSubscribeIot = () => {
    if (iotSub) {
      iotSub.unsubscribe()
      setIotStartTime(0)
      setIotStopTime(0)
      setIotWeight({ weight: 0, timestamp: '' })
      setIotEnabled(false)
      console.log('iot', 'unsubscribe')
    }
  }

  const errorIotAndReConnect = () => {
    unSubscribeIot()
    setIotEnabled(false)
    setShowErrorIot(null)

    setTimeout(() => {
      subscriptionIot()
    }, 500)
  }

  useEffect(() => {
    if (iotSub && iotSub.closed === false) {
      setIotEnabled(true)
    }
    unSubFunc.current = unSubscribeIot
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const mergedWorkCenters = mergeUpdateToOriginWorkCenters(workCenters, updatedOperations)

  const isDraftedWC = currentOperation.status && (
    currentOperation.status === OrderStatusCode.DRAFTED || currentOperation.status === OrderStatusCode.CONFIRMED
  )

  const isPD = user.department === Department.PRODUCTION
  const isQC = user.department === Department.QC
  
  const timeTypeMenus = Object.values(OperationTime)
    .map(t => ({ 
      timeType: t,
      active: t === OperationTime.SOAP_BASE ? currentOperation.operationNo === '0010' : true // condition for SOAP Base
    }))
  
  const inspectBulkLogs = useMemo(() => operationLogs.filter(log => log.timeType === OperationTimeQC.INSPECT_BULK), [ operationLogs ])

  const inspectBulkLogsColumns = useMemo(() => {
    if (readOnly || !isQC) {
      let cols = Array.from(InspectBulkLogsColumns)
      cols.splice(cols.length - 2, 2)
      return cols
    }
    return InspectBulkLogsColumns
  }, [ readOnly, isQC ])

  const onInspectBulkRowClick = (
    row: DgtPdOrderOperationLog,
    column: CalculatedColumn<DgtPdOrderOperationLog>) => {
    if (column.key === 'edit') {
      setEditLogId(row.id)
      setShowBulkInspectForm(true)
    } else if (column.key === 'delete') {
      onDeleteRecord(row.id, row.downtimeCode)
    }
  }

  const [ fgInspectionLogs, mutate ] = useFGInpsectionLog({
    productionOrder: order,
    workCenterId: currentOperation.actualWorkCenterId ? currentOperation.actualWorkCenterId : currentOperation.workCenterId,
    department: currentDepartment,
    isRefresh,
    isPreProduction: !currentOperation.isRequiredBatchLotNo || !currentOperation.isRequiredFGInspect,
    machineCategory: currentOperation.machineCategory
  });

  return <>{currentTimeType === '' ?
    <div className="pb-1 mt-1 mt-md-3">
      <div className='pb-3 space-y-3'>
        {/* top side menu */}
        <div className='flex items-start justify-between '>
          <div className='grid w-full grid-cols-1 gap-3 md:grid-cols-2 '>
            {mergedWorkCenters.map(wc =>
              <button key={wc.id}
                className={` p-2 px-3 text-left rounded-md border${currentOperationNo === wc.operationNo ? ' bg-blue-100 border-blue-600':''}`}
                onClick={() => setCurrentOperationNo(wc.operationNo)}>
                  <div className="flex items-center gap-1 break-words">
                    <h6>
                      {wc.createdBySystem === 'APP' ? <Badge variant="new mr-1">ใหม่</Badge> : null}
                      {wc.active ? ( wc.status === OrderStatusCode.DRAFTED || wc.status === OrderStatusCode.CONFIRMED ? 
                        <Badge variant={OrderStatusTheme[wc.status]}>{OrderStatusDisplay[wc.status]}</Badge> : null
                      ) : <Badge variant="danger">ปิด</Badge>}
                    </h6>
                    {wc.actualWorkCenterId ? 
                    <h6 className={`${currentOperationNo === wc.operationNo ? 'text-blue-600':''}`}>{wc.operationNo} - {wc.actualWorkCenterDescription} ({wc.actualWorkCenterId})</h6> : 
                    <h6 className={`${currentOperationNo === wc.operationNo ? 'text-blue-600':''}`}>{wc.operationNo} - {wc.workCenterDescription} ({wc.workCenterId})</h6>}
                    {mergedWorkCenters.length > 1 ? <small className={`${currentOperationNo === wc.operationNo ? '':'hidden '}text-xs underline text-muted ml-auto`}
                      onClick={readOnly || !isPD ? undefined : () => setShowConfirmDisableOp(true)}>{wc.active ? 'ปิดไม่ใช้งาน' : 'เปิดทำงาน'}</small> : null}
                  </div>
              </button>
            )}
          </div>
          <button
            className={`w-20 work-center-edit${readOnly || !isPD ? ' text-gray-500' : ''}`}
            onClick={(readOnly || !isPD || isDraftedWC) ? undefined : () => setShowDialogAddOp(true)}
          >เพิ่ม OP</button>
        </div>
        {/* bottom side menu */}
        <div className={`${workCenters.length > 0 ? '':'hidden'} lg:basis-5/6`}>
          <div className='flex flex-col justify-between mb-3 md:flex-row lg:mb-2'>
            <div className='flex justify-between md:justify-start'>
              <h6>{currentOperation.actualWorkCenterId ? 
                <strong className='text-green-700 '>{`WC: ${currentOperation.actualWorkCenterId} - ${currentOperation.actualWorkCenterDescription}`}
                </strong> : null}
              {currentOperation.actualWorkCenterId ? <br></br> : null}{<span className={currentOperation.actualWorkCenterId ? 'line-through' : ''}>{`WC: ${currentOperation.workCenterId} - ${currentOperation.workCenterDescription}`}</span>}</h6>
              {currentOperation.active && !isDraftedWC ? 
                <h6 className={`ml-2 work-center-edit${readOnly || !isPD ? ' text-gray-500' : ''}`}
                  onClick={readOnly || !isPD ? undefined : () => setShowEditWc(true)}>แก้ไข</h6>
              : null}
            </div>
            {isQC ? <button className='flex gap-1 btn-primary'
                disabled={readOnly}
                onClick={() => setShowBulkInspectForm(true)}>
                  <HiMagnifyingGlass />บันทึกผล BULK
              </button> : <div className='flex items-center justify-end gap-2 mt-3 md:mt-0'>
              <div className={`flex items-center justify-center gap-2`}>
                <div className='flex items-center gap-1'>
                  <BiChip className={iotEnable ? ' text-green-600':'text-muted'} size={20}/>
                </div>
                <Switch
                  checked={iotEnable}
                  onChange={onSwitchConnectChanged}
                  className={`${
                    iotEnable ? 'bg-green-600' : 'bg-gray-200'
                  } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-green-700 focus:ring-offset-2`}
                  disabled={readOnly || !isPD}
                >
                  <span
                    className={`${
                      iotEnable ? 'translate-x-6' : 'translate-x-1'
                    } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                  />
                </Switch>
              </div>
              <DropdownMenu
                title='บันทึกเวลาผลิต'
                menus={timeTypeMenus}
                disabled={isDraftedWC || !currentOperation.active || readOnly || disableRecord}
                onMenuSelected={onClickStartRecord}
              />

              {order.materialType === OrderType.FG && currentOperation.isRequiredFGInspect && <button
                className={`h-fit text-sm ${!currentOperation.active || readOnly || !isPD ? "btn-outline-fg-inspection":"btn-fg-inspection"}`}
                disabled={!currentOperation.active || readOnly || !isPD}
                onClick={() => setShowFgInspectForm(true)}>
                <HiMagnifyingGlass className='mr-2 ' />บันทึกคุณภาพ FG
              </button>}
              <button className={`h-fit text-sm ${!currentOperation.active || isDraftedWC ? "btn-outline-success":"btn-success"}`}
                disabled={!currentOperation.active || isDraftedWC || readOnly || !isPD}
                onClick={onFinishedProduce}>
                  <AiOutlineFileDone className='mr-2 ' />จบขั้นตอน
              </button>
            </div>}
          </div>
          {invalidRtOt ? <h6 className='flex justify-end gap-1 text-sm text-center text-red-500'><RiUserUnfollowLine size={20} />กรอกคน RT/OT ไม่ครบ, ไม่หยุดเวลา หรือ BatchNo มีช่องว่าง</h6> : null}
          <div className='mb-5 overflow-x-auto'>
            <OperationLogTable
              logs={operationLogs}
              onEdit={onEditRecord}
              onDelete={onDeleteRecord}
              showAllCol={true} 
              isEdit={!isDraftedWC && !readOnly}
              orderType={order.materialType}
              onViewLog={onViewRecord}
            />
            <div className={`flex justify-center items-baseline gap-2 py-3`}>
              <p className='font-bold '>ผลิตได้รวม</p>
              <label className="text-4xl font-bold text-green-500">
                {formatNumberV2(ceil2Decimal(operationLogs.reduce((prev, { yield : y }) => prev + y, 0)),)}
                <span className='text-sm font-normal text-muted'> {order.materialUnit}</span>
              </label>
            </div>
          </div>
          {inspectBulkLogs.length > 0 ? <>
            <h6 className='underline '>ผลการทดสอบ BULK โดย QC</h6>
            <DataGrid
              style={{ height: "fit-content", contain: "none" }}
              columns={inspectBulkLogsColumns}
              rows={inspectBulkLogs}
              onRowClick={onInspectBulkRowClick}
              rowKeyGetter={row => row.id}
              defaultColumnOptions={{ resizable: true }}
            />
          </> : null}
        </div>
      </div>
    </div> : <WorkCenterForm workCenter={currentOperation} timeTitle={currentTimeType}
      onBack={onBackFromRecord} logId={editLogId} lastLogs={operationLogs.slice(-1)}
      iotStartTime={iotStartTime} iotStopTime={iotStopTime} iotEnable={iotEnable} iotWeight={iotWeight}
      isRequiredBatchLotNo={currentOperation.isRequiredBatchLotNo}
    />}
    <div className='absolute bottom-[40] right-[40]'>
      <Alert
        onClose={() => setShowToast(false)}
        show={showToast}
        variant="success"
        dismissible
        styles='fixed -translate-x-1/2 -translate-y-1/2 bottom-8 left-1/2 z-[1000]'
      >
        <div className='flex items-center gap-3'>
          <BsStopwatch /> ระบบหยุดเวลาการบันทึกก่อนหน้าให้อัตโนมัติ
        </div>
      </Alert>
    </div>
    {showEditWc ? <EditWorkCenter currentWorkCenter={currentOperation} show={showEditWc} onHide={onEditWorkCenterCompleted}
      division={order.division} orderType={order.materialType}/> : null}
    <Modal show={showConfirmDelete} onHide={() => setShowConfirmDelete(false)}
      title='ลบข้อมูลที่เคยบันทึก'
      cancelText='ยกเลิก'
      okText='ยืนยัน'
      okTheme='danger'
      okAction={onConfirmDelete}>
      <h6>ผู้ร่วมงานยืนยันที่จะลบข้อมูล ?</h6>
    </Modal>
    <Modal show={showConfirmDisableOp} onHide={() => setShowConfirmDisableOp(false)}
      title={currentOperation.active ? 'ปิดไม่ใช้งาน' : 'เปิดทำงาน'}
      cancelText='ยกเลิก'
      okText='ยืนยัน'
      okTheme={currentOperation.active ? "secondary" : "info"}
      okAction={onConfirmEnableDisableOp}>
      <h6>
        ผู้ร่วมงานยืนยันที่จะ {currentOperation.active ? 'ปิดไม่ใช้งาน' : 'เปิดทำงาน'} ?
      </h6>
    </Modal>
    <Modal show={showDialogAddOp} onHide={() => {
        setShowDialogAddOp(false)
        setNewOperation(defaultNewOperation)
      }}
      title='เพิ่ม Operation ใหม่'
      okText='เพิ่ม'
      cancelText='ยกเลิก'
      okTheme='success'
      okAction={onConfirmAddNewOp}>
      <div>
        <label className='inline-block mb-3 '>Operation No.</label>
        <input type="number" inputMode="numeric" placeholder="เลขรัน Operation"
          className='mb-3 input-form-text'
          value={newOperation.operationNo}
          onChange={onNewOperationNoChanged}
          disabled={true}
        />
        <small className={`${newOperation.error ? '':'hidden'} text-red-500`}>
          {newOperation.error}
        </small>
        <label className='inline-block mb-3 '>Work Center</label>
        <SelectWorkCenter
          show={showDialogAddOp}
          onChange={onNewOperationWcChanged}
          setFirstWcValue={onSetFirstNewOperationWc} />
      </div>
    </Modal>
    {showConfirmSaveDraft ?
    (
      order.id.startsWith('8') ?
      <SaveDraftDialogBulk
        show={showConfirmSaveDraft}
        id={currentOperation.id}
        operationNo={currentOperationNo}
        workCenter={currentOperation}
        orderQty={order.orderQty}
        unit={order.materialUnit}
        onCancel={() => setShowConfirmSaveDraft(false)}
        onConfirm={onConfirmSaveDraftOperation}
        logs={operationLogs}
      />
      :
      showConfirmSaveDraft && <SaveDraftDialogFG
        show={showConfirmSaveDraft}
        id={currentOperation.id}
        workCenter={currentOperation}
        orderQty={order.orderQty}
        unit={order.materialUnit}
        orderType={order.orderType}
        material={`${order.materialDescription} (${order.materialCode})`}
        onCancel={() => setShowConfirmSaveDraft(false)}
        onConfirm={onConfirmSaveDraftOperation}
        logs={operationLogs}
        isPreProduction={!currentOperation.isRequiredBatchLotNo || !currentOperation.isRequiredFGInspect}
        // Note : isPreProduction can use flag both !isRequiredBatchLotNo or !isRequiredFGInspection
        fgInspectionLogs={fgInspectionLogs}
        onReloadFGInspections={() => setIsRefresh(!isRefresh)}
      />
    )
    : null
    }
    <Modal show={showErrorIot !== null}
      title='IOT Something Error'
      okText='เชื่อมต่อใหม่'
      okTheme='success'
      okAction={errorIotAndReConnect}>
      {showErrorIot ? 
      <h6>{showErrorIot.errorCode} - {showErrorIot.errorMessage}</h6> : ''}
    </Modal>
    <BulkInspectForm
      show={showBulkInspectForm}
      onHide={() => {
        setEditLogId('')
        setShowBulkInspectForm(false)
      }}
      productionOrder={order}
      operation={currentOperation}
      editLogId={editLogId}
    />

    <Modal
      show={logForView !== undefined}
      title='Debug Mode - ดูข้อมูล'
      onHide={() => setLogForView(undefined)}
      maxWidth={'max-w-4xl'}
      cancelText={'ปิด'}
      cancelAction={() => setLogForView(undefined)}
    >
      {logForView ? <div className='grid grid-cols-2'>
        {Object.keys(logForView).map(k => <div className='text-sm' key={k}>
          <span className='font-bold '>{k}</span> : {logForView[k] ? logForView[k] : '-'}
        </div>)}
      </div> : null}
    </Modal>
    {showFgInspectForm && <FGInspection
      show={showFgInspectForm}
      onHide={() => setShowFgInspectForm(false)}
      productionOrder={order}
      operation={currentOperation}
      fgInspectionLogs={fgInspectionLogs}
      mutate={mutate}
    />}
  </>
}

const getFlagsOfWorkCenter = async (wcNo) => {
  const workCenter = await DataStore.query(DgtPdWorkCenter, wcNo)
  if (!workCenter) return {
    isRequiredManHour: true,
    isRequiredBatchLotNo: true,
    isRequiredFGInspect: false,
    machineCategory: null,
    sapCategoryCode: null,
    sapCategoryName: null
  }

  return {
    isRequiredManHour: workCenter.isRequiredManHour,
    isRequiredBatchLotNo: workCenter.isRequiredBatchLotNo !== null ? workCenter.isRequiredBatchLotNo : true,
    isRequiredFGInspect: workCenter.isRequiredFGInspect !== null ? workCenter.isRequiredFGInspect : false,
    machineCategory: workCenter.machineCategory || null,
    sapCategoryCode: workCenter.sapCategoryCode || null,
    sapCategoryName: workCenter.sapCategoryName || null
  }
}

const mergeUpdateToOriginWorkCenters = (originWcs, updatedWorkCenter) => {
  if (!updatedWorkCenter) return originWcs

  const tempWcs = [...originWcs]
  Object.keys(updatedWorkCenter).forEach(key => {
    const idx = tempWcs.findIndex(wc => wc.operationNo === key)
    if (idx < 0) {
      tempWcs.push(updatedWorkCenter[key])
    } else {
      tempWcs[idx] = { ...tempWcs[idx], ...updatedWorkCenter[key] }
    }
  })
  return tempWcs
}

const countEditOperation = (workCenters) => {
  return workCenters.reduce((prev, cur) => prev +
    ((cur.createdBySystem === 'SAP' && !cur.active) || (cur.createdBySystem === 'APP' && cur.active)), 0)
}

export default memo(WorkCenterDraft)